import { css } from "styled-components";

export const timePickerStyles = css`
  .ant-picker-clear svg {
    fill: ${(p) => p.theme.colors.secondaryGrey};
  }
  .ant-picker-dropdown
    .ant-picker-time-panel-column
    > li.ant-picker-time-panel-cell
    .ant-picker-time-panel-cell-inner {
    color: ${(p) => p.theme.colors.primaryGrey};
  }
  .ant-picker-dropdown
    .ant-picker-time-panel-column
    > li.ant-picker-time-panel-cell-selected
    .ant-picker-time-panel-cell-inner {
    background: ${(p) => p.theme.colors.lightBlue};
  }
  .ant-picker-dropdown .ant-picker-time-panel-column:not(:first-child) {
    border-inline-start: ${(p) => p.theme.borders.light};
  }
  .ant-picker-dropdown .ant-picker-footer {
    border-top: ${(p) => p.theme.borders.light};
    .ant-btn-variant-solid {
      color: ${(p) => p.theme.colors.buttonText};
    }
    .ant-btn-variant-solid:disabled {
      color: ${(p) => p.theme.colors.disabledText};
      border-color: ${(p) => p.theme.colors.disabledText};
    }
  }
`;
